import { FC } from 'react';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  referringUrls: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['referringUrls'] | null;
}

export const ReferringUrlsLabel: FC<Props> = ({ referringUrls }) => {
  if (referringUrls) {
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        { referringUrls.map((el, index) => (
          <li key={ index }>{ el }</li>
        )) }
      </ul>
    );
  } else {
    return <span>Нічого не виявлено</span>;
  }
};
